import { AI_IMAGE_MONTHLY_LIMIT, AI_IMAGE_OVERAGE_RSD } from '../constants/aiImagePackageLimits';

/** Jedna stavka liste karakteristika paketa: mesečni AI limit + napomena o doplati po slici. */
export function aiImageFeatureForPackage(t, packageKey) {
  const count = AI_IMAGE_MONTHLY_LIMIT[packageKey];
  return {
    included: true,
    text: t('superAdmin.packages.aiImagesFeatureTitle', {
      count,
      defaultValue: `Do ${count} AI obrada slika mesečno (uključeno u pretplatu)`,
    }),
    detail: t('superAdmin.packages.aiImagesOverageNote', {
      price: AI_IMAGE_OVERAGE_RSD,
      defaultValue: `Svaka dodatna slika iznad paketa obračunava se po ${AI_IMAGE_OVERAGE_RSD} din.`,
    }),
  };
}
